import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { TicketsContent } from '@starjack/widgets/tickets';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';
import { Helmet } from 'react-helmet-async';

const Tickets: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Tickets | Starjack Admin</title>
            </Helmet>
            <TicketsContent />
        </>
    );
};

Tickets.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
Tickets.isProtected = true;
Tickets.permissions = [Permission.TICKETS_NAV, Permission.TICKETS_CANCEL];

export default Tickets;
